import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { useEffect, useState } from "react"
import { useStore } from "../../../contexts/store"
import api from "../../../api/api"
import { Op } from "../../../shared/src/types/Ops"
import { PodClass } from "../../../classes/Pod"

import { Box } from "@mui/material"
import IconStream from "../Activity/IconStream"
import Operation from "../Activity/Operation"
import { objectExists } from "../Activity/Activity"


const ActivityPreview = ({pod}: {pod: PodClass}) => {
  const { t } = useTranslation()
  const { podStore, sessionStore } = useStore()
  const [ activities, setActivities ] = useState<Op[]>([])
  const [ isLoading, setIsLoading ] = useState(false)
  const podActivity = podStore.getPodActivity(pod.podId)

  useEffect(() => {

    const refreshPodActivity = async() => {
      setIsLoading(true)
      const data = await api.getPodActivity(pod.podId, 0)
      if (data && data.status === 200) {
        podStore.setPodActivity(data.body)
      }
      setIsLoading(false)
    }

    const activityData:Op[]|null = pod ? podActivity : null
    if (activityData) setActivities(activityData)
    // load data
    if ((!isLoading) && (activityData === null)) {
      if (pod.podId) refreshPodActivity()
    }
  }, [isLoading, pod, pod.podId, podStore, podActivity])

  if (!sessionStore.session) return null
  const userId = sessionStore.session.user.userId

  const Activity = observer(({activity}: {activity: Op}) => (
    <Box sx={{
      display: "grid",
      gridTemplateColumns: "min-content auto"
    }}>
      <IconStream interactionType={activity.op} isPreview={true} />
      <Operation op={activity} userChanged={false} isPreview={true} />
    </Box>
  ))

  return (
    <Box sx={{
      display: "grid",
      margin: "15px 30px 30px 30px",
      wordBreak: "break-word"
    }}>
      {activities.length === 0 ?
        <Box sx={{
          display: "grid",
          fontSize: "17px",
          fontStyle: "italic",
          fontWeight: 300,
          justifyContent: "center",
          padding: "8px",
          margin: "30px"
        }}>
          {t('No activity yet')}
        </Box>
      :
        activities.filter(activity => objectExists(activity, pod, userId)).slice(0,4).map(activity =>
          <Activity key={activity.oid} activity={activity} />
        )
      }
    </Box>
  )
}

export default observer(ActivityPreview)